import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CiStep, pad } from '../config/ci-steps.config';
import { StepId } from '../models/ci-form.model';

/** The "01 · Property" pill row. Pills are the only step navigation. */
@Component({
  selector: 'ci-step-pills',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ci-step-pills.component.html',
})
export class CiStepPillsComponent {
  /** Flow-specific — four pills for land, five for units. */
  readonly steps = input.required<readonly CiStep[]>();
  readonly current = input.required<StepId>();
  readonly completed = input.required<ReadonlySet<StepId>>();
  readonly furthestIndex = input.required<number>();
  /** Saved drafts can be resumed from any step, even when incomplete. */
  readonly unlocked = input(false);

  readonly stepSelect = output<StepId>();

  pad = pad;

  indexOf(step: CiStep): number {
    return this.steps().findIndex((s) => s.id === step.id) + 1;
  }

  isCurrent(step: CiStep): boolean {
    return step.id === this.current();
  }

  isReachable(step: CiStep): boolean {
    return this.unlocked() || this.indexOf(step) <= this.furthestIndex();
  }

  pillClass(step: CiStep): string {
    if (this.isCurrent(step)) {
      return 'border-indigo-600 bg-indigo-600 text-white';
    }
    if (this.completed().has(step.id)) {
      return 'border-indigo-200 bg-indigo-50 text-indigo-700 hover:bg-indigo-100';
    }
    if (this.isReachable(step)) {
      return 'border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:text-slate-900';
    }
    return 'border-slate-200 bg-white text-slate-400';
  }
}
